import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, TableSortLabel } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import * as Constants from '../Constants';
import '../App.css';

const SiteAdminList = () => {
  const [admins, setAdmins] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAdmins = async () => {
      const params = {
        roles: Constants.ROLE_COMMUNITY_ADMIN
      };
      rpc({
        method: "GetUsers",
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: setAdmins
      });
    };
    fetchAdmins();
  }, []);

  const createSiteAdmin = () => {
    navigate(`/createSiteAdmin`);
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedAdmins = admins.slice().sort((a, b) => {
    if (orderBy === 'last') {
      return (order === 'asc' ? a.last.localeCompare(b.last) : b.last.localeCompare(a.last));
    } else if (orderBy === 'first') {
      return (order === 'asc' ? a.first.localeCompare(b.first) : b.first.localeCompare(a.first));
    } else if (orderBy === 'email') {
      return (order === 'asc' ? a.email.localeCompare(b.email) : b.email.localeCompare(a.email));
    } else if (orderBy === 'site') {
      return (order === 'asc' ? a._site.name.localeCompare(b._site.name) : b._site.name.localeCompare(a._site.name));
    }
    return 0;
  });

  return (
    <div className="SiteAdminList">
      <TableContainer className="TableContainer" component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === 'last'}
                  direction={orderBy === 'last' ? order : 'asc'}
                  onClick={() => handleSort('last')}
                >
                  <b>Last</b>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === 'first'}
                  direction={orderBy === 'first' ? order : 'asc'}
                  onClick={() => handleSort('first')}
                >
                  <b>First</b>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === 'email'}
                  direction={orderBy === 'email' ? order : 'asc'}
                  onClick={() => handleSort('email')}
                >
                  <b>Email</b>
                </TableSortLabel>
              </TableCell>
              <TableCell><b>Phone</b></TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === 'site'}
                  direction={orderBy === 'site' ? order : 'asc'}
                  onClick={() => handleSort('site')}
                >
                  <b>Site</b>
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedAdmins.map((user, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Link to={`/siteAdmin/${user._id}`}>{user.last}</Link>
                </TableCell>
                <TableCell>{user.first}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.phone}</TableCell>
                <TableCell>{user._site.name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button className="Button" variant="contained" color="primary" onClick={createSiteAdmin}>
          Create
      </Button>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default SiteAdminList;
